import type {VersionInfo} from './app/utils.class';

export const compiledVersion: VersionInfo = {"buildNumber":"D. van der Steen B.V_acceptance_2026-11-03_23-0-36","buildId":"24861","environment":"trackline-acceptance","datetime":"2026-11-03T22:02:04.776Z","checkForUpdates":true}